import React, { FC } from "react";
import { Button, ButtonProps } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";

const LinkButton: FC<ButtonProps & LinkProps> = props => (
    <Button component={Link as any} {...props} />
);
export default LinkButton;
